/**
 * WbSectionKop — groepskop: uppercase label, mono-teller, optionele
 * rechteractie (Ververs, Alles) en een regel uitleg eronder.
 */

import clsx from 'clsx';

export interface WbSectionKopProps {
  label: string;
  teller?: number | string | null;
  /** Rechts in de kop, meestal een WbButton variant="link". */
  actie?: React.ReactNode;
  uitleg?: string | null;
  className?: string;
  /** Kop als <h2> (standaard) of <h3> binnen een sectie. */
  niveau?: 2 | 3;
}

export function WbSectionKop({ label, teller, actie, uitleg, className, niveau = 2 }: WbSectionKopProps) {
  const Kop = niveau === 3 ? 'h3' : 'h2';
  return (
    <div className={clsx('space-y-0.5', className)}>
      <div className="flex items-center justify-between gap-2 min-h-[28px]">
        <Kop className="font-wb-heading font-bold text-xs uppercase tracking-wide text-wb-inkt2">
          {label}
          {teller !== undefined && teller !== null && <span className="font-mono ml-1.5">{teller}</span>}
        </Kop>
        {actie}
      </div>
      {uitleg && <p className="text-sm text-wb-inkt2">{uitleg}</p>}
    </div>
  );
}
